import React from 'react';
import InputLabel from '../InputLabel/InputLabel.jsx';
import BaseTextInput from '../BaseTextInput/BaseTextInput.jsx';
import InputError from '../InputError/InputError.jsx';
import { Skeleton } from '../../layout/loading';

export default function TextInputField({
  register,
  errors,
  registerOptions = {},
  name,
  placeholder = '',
  labelText = '',
  labelRightElement = null,
  maxLength,
  showCount = false,
  currentLength,
  loading = false,
  ...props
}) {
  if (loading) {
    return (
      <div>
        {labelText && <Skeleton variant="text" className="w-24 mb-2" />}
        <Skeleton variant="rectangular" className="h-9 w-full rounded-md" />
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <InputLabel htmlFor={name} labelRightElement={labelRightElement}>{labelText}</InputLabel>
        {showCount && maxLength && (
          <span className="text-xs text-gray-400" id={`${name}-description`}>
            {currentLength !== undefined ? `${currentLength}/` : 'Max '}{maxLength} characters
          </span>
        )}
      </div>
      <div className="mt-2">
        <BaseTextInput
          id={name}
          {...props}
          maxLength={maxLength}
          {...register(name, registerOptions)}
          placeholder={placeholder}
        />
      </div>
      {errors[name] && <InputError>{errors[name].message}</InputError>}
    </div>
  );
}
